export const INCENTIVES_HELP_URL = 'https://help.bonus.ly/en/articles/11503498-incentives';
export const INCENTIVES_BLOG_URL = 'https://bonusly.com/post/reward-to-reinforce-11-proven-incentives-from-bonusly-customers';
